(function () {
    'use strict';

    angular
        .module('app.paymentGateways')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'paymentgateways',
                  config: {
                      abstract: true,
                      url: '/paymentgateways',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'paymentgateways.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/paymentgateways/list.html?v=' + opsIncludeVersion,
                    controller: 'PaymentGatewayListController',
                    controllerAs: 'vm',
                    title: 'Payment Gateways'
                }
            },
            {
             state: 'paymentgateways.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/paymentgateways/details.html?v=' + opsIncludeVersion,
                 controller: 'PaymentGatewayDetailsController',
                 controllerAs: 'vm',
                 title: 'Payment Gateway',
                 settings: {}
             }
            }
          
        ];
    }
})();
